<script lang="ts">
  import { ICONS, type IconName } from '../lib/icons';

  let {
    name,
    size = 16,
    strokeWidth = 1.75,
    class: cls = '',
  }: { name: IconName; size?: number; strokeWidth?: number; class?: string } = $props();

  // lucide-svelte@1 типізує іконки як legacy-компоненти → рендеримо як any.
  const Cmp = $derived(ICONS[name] as unknown as any);
</script>

<Cmp {size} {strokeWidth} class={cls} />
